import React, { useEffect } from 'react'

import sections from '../data/sections'

import StartSectionBtn from './StartSectionBtn'

const StartPage = () => {
    useEffect(() => {
        document.getElementById("top-anchor").scrollIntoView({behavior:"smooth"})
      }, [])

    const handleClick = () => {
        document.getElementById("bottom-anchor").scrollIntoView({behavior:"smooth"})
    }

    const handleScroll = () => {
        if (!!document.getElementById("scroll-btn")) {
            document.getElementById("scroll-btn").classList.add("hidden")
            setTimeout(() => document.getElementById("scroll-btn").classList.add("deleted"), 500)
        }
    }
    window.addEventListener("scroll", handleScroll, {once:true})

    return (
        <div className="grid-container page">
            <div className="menu-intro">
            <h3 className="bold">Is your practice ready to offer telehealth services?</h3>
            <p>This telehealth readiness assessment tool is intended to be completed in around 20 minutes by the lead physician or office manager in collaboration with other stakeholders in their practice.</p>
            <p className="bold">Select one of the five key concepts of telehealth to get started. The concepts may be completed in any order.</p>
            </div>

            <div className="section-btns-list">
            { sections.map((section) =>
                <StartSectionBtn section={ section } key={ section.secId }></StartSectionBtn>
            )}
            </div>

            <div id="bottom-anchor"></div>

            <div id="scroll-btn" className="scroll-down-bar" onClick={handleClick}>     
                <svg width="50px" height="35px" viewBox="0 0 50 35" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                    <g fill="#333366">
                        <path d="M1.01219841,6.81250842 L0.99136662,6.81250842 C-0.366232515,5.21265824 -0.324262312,2.66643113 1.08510969,1.12535098 C2.4944817,-0.415729176 4.73755501,-0.368086692 6.09515419,1.23176345 L25.0104159,23.4365072 L43.9048458,1.23176345 C45.2624449,-0.368086732 47.5055183,-0.415729236 48.9148903,1.12535094 C50.3242623,2.66643111 50.3662325,5.21265824 49.0086333,6.81250842 L25.0104159,35 L1.01219841,6.81250842 Z" id="Shape"></path>
                    </g>
                </svg>
            </div>

        </div>
    )
}

export default StartPage


// WEBPACK FOOTER //
// ./src/components/StartPage.js